import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { mapState, mapMutations } from 'vuex';
// import mixin from '../mixin/controlMixin';
import singLine from './singLine.vue'; //单行文本
import controlAction from './controlAction.vue';
import groupControlItem from './groupControlItem.vue';
export default {
  // mixins: [mixin],
  components: {
    singLine,
    controlAction,
    groupControlItem
  },
  props: {
    groupItem: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState('control', ['controlDatas', 'groupSelected', 'activeIdx', 'groupItemActiveIdx']),
    item: {
      get() {
        return this.groupItem;
      },
      set(val) {
        this.$emit('groupItem', val);
      }
    },
    formDataArray: {
      get() {
        return this.controlDatas;
      },
      set(val) {
        this.$emit('formDataArray', val);
      }
    }
  },
  watch: {},
  data() {
    return {
      rulesTrue: {
        //统一控件说明如下：
        // 名称设置：
        // 控件名称：单行文本框，限制为0-500个字符。
        // 默认情况下，将填入控件类型的名称。
        // 非必填。如果删除了控件名称，在控件位置上方会进行补位。如果控件名称过长，会根据页面宽度换行显示。
        controlName: [{
          required: false,
          message: this.$t('请输入') + this.$t('控件名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: this.$t('长度在 1 到 500 个字符之间'),
          trigger: 'blur'
        }],
        promptText: [{
          message: this.$t('长度最多为 100 个字符'),
          trigger: 'blur'
        }],
        controlExplain: [{
          max: 100,
          message: this.$t('长度最多为 100 个字符'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入标识'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 50 个字符之间'),
          trigger: 'blur'
        }],
        prefix: [{
          message: this.$t('请输入...'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度在 1 到 50个字符'),
          trigger: 'blur'
        }],
        suffix: [{
          message: this.$t('请输入....'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度在 1 到 100个字符'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入....'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 100个字符'),
          trigger: 'blur'
        }],
        phoneRules: [{
          required: true,
          message: this.$t('请输入手机号'),
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: this.$t('手机号格式不正确'),
          trigger: 'blur'
        }],
        idCardRules: [{
          required: true,
          message: this.$t('请输入身份证号')
        }, {
          pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
          message: this.$t('身份证号格式不正确')
        }],
        emailRules: [{
          required: false,
          message: this.$t('请输入邮箱'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]{1,18}@[a-zA-Z0-9]+\.com$/,
          message: this.$t('邮箱格式不正确'),
          trigger: 'blur'
        }],
        // 文件格式验证
        fileFormat: [{
          type: 'array',
          required: true,
          message: this.$t('请选择') + this.$t('文件格式'),
          trigger: 'change'
        }],
        // // 文件大小
        // fileSize: [{type: 'number', required: true, message: this.$t('请选择') + this.$t('文件大小'), trigger: 'blur'}],
        // //日期
        // dateType: [{required: true, message: this.$t('请选择') + this.$t('日期类型'), trigger: 'change'}]
        // 选项值文本
        name: [{
          required: true,
          message: this.$t('选项值不能为空'),
          trigger: 'blur'
        }]
      }
    };
  },
  created() {},
  methods: {
    ...mapMutations({
      SET_GROUP_SELECTED: 'control/SET_GROUP_SELECTED',
      SET_ACTIVE_IDX: 'control/SET_ACTIVE_IDX',
      SET_CONTROL_DATAS: 'control/SET_CONTROL_DATAS',
      SET_GROUP_ITEM_ACTIVE_IDX: 'control/SET_GROUP_ITEM_ACTIVE_IDX'
    }),
    // 点击显示  下拉、上移、编辑按钮
    toggleSelection(index) {
      // 提交store
      this.SET_ACTIVE_IDX(index);
      this.SET_GROUP_SELECTED(true);
      this.changeFormDataArray(index, false);
    },
    // 修改数据的isCheck
    changeFormDataArray(idx) {
      this.formDataArray.forEach((item, index) => {
        //选中控件组
        if (idx === index) {
          item.isCheck = true;
          item.groupSelected = true;
          if (this.groupItemActiveIdx !== -1) {
            var _item$control;
            (_item$control = item.control) === null || _item$control === void 0 || _item$control.forEach(items => {
              items.groupSelected = true;
              items.isCheck = false;
              // console.log('----取消选中-----', items);
            });
            this.SET_GROUP_ITEM_ACTIVE_IDX(-1);
            // this.$forceUpdate();
          } else {
            var _item$control2;
            (_item$control2 = item.control) === null || _item$control2 === void 0 || _item$control2.forEach(items => {
              items.groupSelected = true;
              items.isCheck = false;
              // console.log('------bbbbbbbbbb---', items);
            });
          }

          // console.log('------选中当前控件---', item);
        } else {
          var _item$control3;
          // 取消选中控件组的item
          item.isCheck = false;
          item.groupSelected = false;
          (_item$control3 = item.control) === null || _item$control3 === void 0 || _item$control3.forEach(items => {
            items.isCheck = false;
            items.groupSelected = false;
          });
          // console.log('------取消选中当前控件---', item);
        }
      });
      this.SET_CONTROL_DATAS(this.formDataArray);
      // console.log(this.formDataArray,'----------控件组页面点击----------')
      this.$forceUpdate();
    },
    // 关联控件
    relationClick(index) {
      this.$emit('relationClick', index);
    },
    // 编辑按钮--打开内容输入内容
    formeClick() {
      this.$set(this.item, 'editing', !this.item.editing);
    },
    // 关闭事件
    formeClose() {
      this.$set(this.item, 'editing', false);
    }
  }
};